import React, { useState } from "react";

function lerAviso() {
  try {
    return JSON.parse(sessionStorage.getItem("aviso_mensalidade") || "null");
  } catch {
    return null;
  }
}

export default function AvisoMensalidade() {
  const [aviso, setAviso] = useState(lerAviso);
  if (!aviso) return null;

  const vencimento = new Date(aviso.assinaturaExpiraEm).toLocaleDateString("pt-BR");
  const prazo = aviso.diasRestantes <= 0
    ? `Sua assinatura venceu em ${vencimento}.`
    : aviso.diasRestantes === 1
      ? `Sua assinatura vence amanhã, ${vencimento}.`
      : `Sua assinatura vence em ${aviso.diasRestantes} dias, em ${vencimento}.`;

  function fechar() {
    sessionStorage.removeItem("aviso_mensalidade");
    setAviso(null);
  }

  return (
    <div
      className="alert alert-warning alert-dismissible shadow"
      role="alert"
      style={{
        position: "fixed",
        zIndex: 1400,
        top: 82,
        left: "50%",
        width: "min(680px, calc(100% - 28px))",
        transform: "translateX(-50%)",
      }}
    >
      <strong>{prazo}</strong>{" "}
      Renove sua assinatura para continuar utilizando todos os recursos do sistema.
      <button type="button" className="btn-close" aria-label="Fechar aviso" onClick={fechar} />
    </div>
  );
}
